<template>
  <section class="assonance-allteteration-settings py-1" 
    :class="{'bg-white' : showXXALSettings}">
    <div 
      class="d-flex justify-content-between px-2 position-relative"
      style="cursor:pointer"
      @click="togglexxAlSettings"
    >
      <h3 class="m-0" :class="{'text-primary' : showXXALSettings}">
        {{searchModel === 'tavnit' ? 'תבנית מילה' : hebrew ? 'מצלול/אליטרציה' : 'Assonance/Alliteration'}}
        <small 
          style="font-size:7px;top:-3px;" 
          class="position-relative"
          v-if="showSettingsChanges">
            <i class="text-primary fas fa-circle"></i>
        </small>
      </h3>
      <i v-if="showXXALSettings" class="fas fa-sort-up text-primary" style="margin-top:6px;"></i>
      <i v-if="!showXXALSettings"  class="fas fa-sort-down" ></i>
    </div>    
    <div class="advanced-rhyme-options settings-wrap px-2 pt-1" v-if="showXXALSettings">
      <LetSwapOption v-if="searchModel!=='tavnit'"></LetSwapOption>
      <TextStyle v-if="searchModel!=='tavnit'"/>            
      <AccentSettings v-if="searchModel==='tavnit'"></AccentSettings>
    </div>        
  </section>
</template>
<script>
  import LetSwapOption from '@/components/letSwapOption'
  import AccentSettings from '@/components/AccentSettings'
  import TextStyle from '@/components/TextStyle'
  import {BlankState} from '@/store/stateChanges'

  export default  {
    name: 'AssonanceAlliterationSettings',
    components: {LetSwapOption, AccentSettings, TextStyle},
    data() {
      return {
        showXXALSettings: false
      }
    },     
    methods: {
      togglexxAlSettings () {
        this.showXXALSettings = !this.showXXALSettings
      }          
    },
    computed: {
      hebrew () {
        return this.$settings.hebrew    
      },
      searchModel () {
        return this.$store.state.searchModel
      },
      showSettingsChanges () {
        if (this.searchModel === 'tavnit') {
          return this.$store.state.preSubmissionOptions.accent !== 'returnall' && this.$store.state.preSubmissionOptions.accent !== 'matchinput'
        } else {
          return JSON.stringify(BlankState.preSubmissionOptions.LetSwapSettings) !==  JSON.stringify(this.$store.state.preSubmissionOptions.LetSwapSettings)
          || BlankState.preSubmissionOptions.includeForeign !== this.$store.state.preSubmissionOptions.includeForeign
          || BlankState.preSubmissionOptions.includeNonBase !== this.$store.state.preSubmissionOptions.includeNonBase
        }
      }
    }
  }
</script>
<style scoped>
  .assonance-allteteration-settings {        
    border-top: 1px solid #c8c8c8;
  }
</style>